import type { ContactSupportData } from '@/src/constants/contactSupport'

/** Digits only (for WhatsApp `phone` query param). */
export const toPhoneDigits = (value: string): string => value.replace(/\D/g, '')

/**
 * WhatsApp Business “click to chat” URL. Only `phone` varies; digits must be country + number, no + or spaces.
 */
export const buildWhatsAppSendUrl = (phoneDigits: string): string =>
    `https://api.whatsapp.com/send/?phone=${phoneDigits}&text&type=phone_number&app_absent=0`

/** First intl WhatsApp line, else digits from `contactNumber` (e.g. FSA). */
export const getWhatsAppSendPhoneDigits = (support: ContactSupportData): string | null => {
    const fromIntl = support.internationalLines?.find(l => l.kind === 'whatsapp')?.value
    const raw = fromIntl ?? support.contactNumber
    const digits = toPhoneDigits(raw)
    return digits.length > 0 ? digits : null
}
